import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "selection-calendar-year-box" }
const _hoisted_2 = { class: "selection-calendar-year-box__label" }

import IconChevronRight from '@/design-system/assets/icons/IconChevronRight.vue'
import IconChevronLeft from '@/design-system/assets/icons/IconChevronLeft.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectionCalendarYear',
  props: {
  leftArrowDisabled: {
    required: true,
    type: Boolean
  },
  rightArrowDisabled: {
    required: true,
    type: Boolean
  },
  label: {
    required: false,
    type: String,
    default: ''
  }
},
  emits: ["leftArrowPressed", "rightArrowPressed"],
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["selection-calendar-year-box__icon-left", { 'selection-calendar-year-box__icon-left__disabled': props.leftArrowDisabled }]),
      role: "button",
      tabindex: "0",
      onClick: _cache[0] || (_cache[0] = 
        () => {
          props.leftArrowDisabled ? null : _ctx.$emit('leftArrowPressed')
        }
      ),
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(
        () => {
          props.leftArrowDisabled ? null : _ctx.$emit('leftArrowPressed')
        }
      , ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(
        () => {
          props.leftArrowDisabled ? null : _ctx.$emit('leftArrowPressed')
        }
      , ["space"]))
      ]
    }, [
      _createVNode(IconChevronLeft)
    ], 34),
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.label), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["selection-calendar-year-box__icon-right", { 'selection-calendar-year-box__icon-right__disabled': props.rightArrowDisabled }]),
      role: "button",
      tabindex: "0",
      onClick: _cache[3] || (_cache[3] = 
        () => {
          props.rightArrowDisabled ? null : _ctx.$emit('rightArrowPressed')
        }
      ),
      onKeydown: [
        _cache[4] || (_cache[4] = _withKeys(
        () => {
          props.rightArrowDisabled ? null : _ctx.$emit('rightArrowPressed')
        }
      , ["enter"])),
        _cache[5] || (_cache[5] = _withKeys(
        () => {
          props.rightArrowDisabled ? null : _ctx.$emit('rightArrowPressed')
        }
      , ["space"]))
      ]
    }, [
      _createVNode(IconChevronRight)
    ], 34)
  ]))
}
}

})